function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
import * as React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css, color } from "../../styles/theme"; // $FlowFixMe

import LazyLoad from 'react-lazyload';
var opacityKeyframes = {
  from: {
    opacity: 0
  },
  to: {
    opacity: 1
  }
};
var styles = StyleSheet.create({
  Placeholder: {
    backgroundColor: color.gray,
    width: '100%',
    height: '100px'
  },
  withFadeIn: {
    animationName: [opacityKeyframes],
    animationDuration: '400ms',
    animationTimingFunction: 'ease',
    animationDelay: '300ms',
    opacity: 1,
    transform: 'translateZ(0)'
  }
});
/*
 * Simple wrapper around react-lazyload for providing lazily rendered components on coursera.
 * For details on props, refer to https://github.com/jasonslyvia/react-lazyload#props
 */

function LazyRender(_ref) {
  var children = _ref.children,
      height = _ref.height,
      once = _ref.once,
      offset = _ref.offset,
      overflow = _ref.overflow,
      debounce = _ref.debounce,
      throttle = _ref.throttle,
      unmountIfInvisible = _ref.unmountIfInvisible,
      placeholderComponent = _ref.placeholderComponent,
      rootClassName = _ref.rootClassName,
      fadeIn = _ref.fadeIn;

  if (!children || children.length === 0) {
    return null;
  }

  var lazyLoadProps = {
    height: height,
    once: once,
    offset: offset,
    overflow: overflow,
    debounce: debounce,
    throttle: !debounce,
    unmountIfInvisible: unmountIfInvisible,
    placeholder: placeholderComponent || React.createElement(Placeholder, {
      height: 200,
      rootClassName: rootClassName
    })
  };
  var lazyLoadedComponent = fadeIn ? React.cloneElement(children, _objectSpread({}, css(styles.withFadeIn))) : // merge fadeIn styles
  children;
  return React.createElement(LazyLoad, _extends({}, lazyLoadProps, css(rootClassName)), lazyLoadedComponent);
} // Default placeholder


function Placeholder(_ref2) {
  var height = _ref2.height,
      rootClassName = _ref2.rootClassName;
  return React.createElement("div", _extends({}, css(styles.Placeholder), {
    style: {
      height: height
    }
  }));
}

LazyRender.propTypes = {
  children: PropTypes.node,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  once: PropTypes.bool,
  offset: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  overflow: PropTypes.bool,
  debounce: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  throttle: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  unmountIfInvisible: PropTypes.bool,
  fadeIn: PropTypes.bool,
  // fade in the children on load
  placeholderComponent: PropTypes.node
};
LazyRender.defaultProps = {
  height: 0,
  once: true,
  offset: 0,
  debounce: false,
  overflow: false,
  throttle: 100,
  // milliseconds
  rootClassName: '',
  unmountIfInvisible: false,
  fadeIn: false
};
export default LazyRender;